import axios from 'axios';
import { toast } from 'react-toastify';
import FileSaver from 'file-saver';
import Amplify, { Analytics, Storage, API, Auth } from 'aws-amplify';

// export const URL = 'http://localhost:5000/api';
export const URL = 'https://ct6quo2u3c.execute-api.ap-southeast-1.amazonaws.com';
const ApiName = 'vopsapi';

export const getApi = async (api) => {
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;
    return API.get(ApiName, api, {
        headers: {
            Authorization: token
        },
    }, {
            validateStatus: (status) => {
                return true;
            },
        }).then((response) => {
            return response;
        }).catch((error) => {
            console.log(error);
            toast.error('Network Error');
        });
};

export const postApi = async (api, data, headers) => {
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;
    return API.post(ApiName, api, {
        headers: {
            Authorization: token
        },
        body: data,
        validateStatus: (status) => {
            return true;
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        console.log(error);
    });
};

export const putApi = (api, data, headers) => {
    return axios({
        method: 'put',
        url: `${URL}/${api}`,
        data: data,
        headers: headers,
        validateStatus: (status) => {
            return true;
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        toast.error('Network Error');
    });
};

export const deleteApi = (api, headers) => {
    return axios({
        method: 'delete',
        url: `${URL}/${api}`,
        headers: {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        },
        validateStatus: (status) => {
            return true;
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        toast.error('Network Error');
    });
};

export const downloadApi = async (api, fileName) => {
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;
    return API.post(ApiName, api, {
        headers: {
            'Content-Type': 'attachment',
            'filename': fileName,
            'Authorization': token,
        },
        responseType: 'arraybuffer',
        validateStatus: (status) => {
            return true;
        },
    }).then((response) => {
        // return response.data;
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, fileName);
    }).catch((error) => {
        console.log(error);

        toast.error('Network Error');
    });
};


// WEBPACK FOOTER //
// ./src/api/api.js